import React, { useState, useMemo } from "react";
import "./Login_signup.css";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import countryList from "react-select-country-list";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import Login_modal from "./Login_modal";
import Signup_Modal from "./Signup_Modal";

const Select_login = ({ setSelectedModal, setShowSucsessModal, setSuccessText, ...props }) => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showSignUp, setShowSignUp] = useState(false);
  const [value, setValue] = useState("");
  const [showLoginModal, setShowLoginModal] = useState(false); // ⬅️ For Login_modal

  const options = useMemo(() => countryList().getData(), []);
  const changeHandler = (value) => setValue(value);

  const handleMobileLoginClick = () => {
    setShowSignUp(true); // Show Login_modal
    props?.onHide(); // Close Select_login modal
  };

  const navigate = useNavigate();

  return (
    <>
      <div className="login_div">
        <div className="login_form_div">
          <Form>
            <Form.Group className="gray_input_group input_group">
              <Form.Label>Choose Your Login Method</Form.Label>

              {/* <Select
                options={options}
                value={value}
                onChange={changeHandler}
              /> */}
            </Form.Group>
          </Form>
        </div>

        <hr />

        <div className="contin_sec"
        // onClick={() => window.open(youtubeLink, "_blank")}
        >
          <Link to={process.env.REACT_APP_GOOGLE_LOGIN}>
            <div className="contbox">
              <p className="contxt">
                <img
                  className="icon"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/google-icon.png"
                  }
                  alt="Google"
                />
                Continue with Google
              </p>
            </div>
          </Link>

          {/* Mobile Login Button */}
          <div
            className="contbox"
            onClick={() => {
              setSelectedModal("login_with_mobile");
            }}
            style={{ cursor: "pointer" }}
          >
            <p className="contxt">
              <img
                className="icon"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/mobile-icon.png"
                }
                alt="Mobile"
              />
              Log in with mobile
            </p>
          </div>
          {/* 
          <Link to={"#"}>
            <div
              className="contbox"
              onClick={() => {
                setSelectedModal("login_with_email");
              }}
              style={{ cursor: "pointer" }}
            >
              <p className="contxt">
                <img
                  className="icon"
                  src={process.env.PUBLIC_URL + "/assets/images/icons/mail.png"}
                  alt="Mail"
                />
                Log in with email
              </p>
            </div>
          </Link> */}
        </div>
        {/* 
        <div className="or_text_div">
          <p className="or_txt">Or</p>
        </div> */}

        {/* <div className="text-center logguest_div">
            <Link to={"/home"}>
              <button
                className="logguest_btn"
                onClick={() => {
                  setSuccessText("Login Succesfully !");
                  props?.onHide();
                  setShowSucsessModal(true);
                  setTimeout(() => {
                    navigate("/home");
                    setShowSucsessModal(false);
                  }, 3000);
                }}
              >
                Log in as Guest
              </button>
            </Link>
          </div> */}

        <p className="dark_text">
          Don't have an account?
          <span
            className="link_text"
            onClick={() => setSelectedModal("sign_up")}
            style={{ cursor: "pointer" }}
          >
            {" "}
            Create Account
          </span>
          .
        </p>
      </div>
    </>
  );
};

export default Select_login;
